import React from "react";
import { Input } from "components/Input";
import { Body, Header } from "components/Table/style";
import { Table } from "../../style";

export function CopperSulfate(props) {
  return (
    <Table>
      <Header>
        <tr>
          <th style={{ width: "185px" }}>
            <span></span>
          </th>
          <th>
            <span>Qual PPM?</span>
          </th>
        </tr>
      </Header>
      <Body>
        <tr>
          <td>Pré</td>
          <td>
            <Input
              type="inputOnly"
              params="minerals.copperSulfate.pre.ppm"
              item={props.broiler}
              setItem={props.setBroiler}
            />
          </td>
        </tr>
        <tr>
          <td>Inicial</td>
          <td>
            <Input
              type="inputOnly"
              params="minerals.copperSulfate.initial.ppm"
              item={props.broiler}
              setItem={props.setBroiler}
            />
          </td>
        </tr>
        <tr>
          <td>Crescimento 1</td>

          <td>
            <Input
              type="inputOnly"
              params="minerals.copperSulfate.growth.ppm"
              item={props.broiler}
              setItem={props.setBroiler}
            />
          </td>
        </tr>
        <tr>
          <td>Crescimento 2</td>

          <td>
            <Input
              type="inputOnly"
              params="minerals.copperSulfate.growth2.ppm"
              item={props.broiler}
              setItem={props.setBroiler}
            />
          </td>
        </tr>

        <tr>
          <td>Final</td>
          <td>
            <Input
              type="inputOnly"
              params="minerals.copperSulfate.final.ppm"
              item={props.broiler}
              setItem={props.setBroiler}
            />
          </td>
        </tr>
      </Body>
    </Table>
  );
}
